import { EmailSupport } from '@components/emailSupport/EmailSupport';
import typography from '~styles/typography.scss';
import styles from './ErrorHero.scss';
import { Button, ButtonVariants } from '@components/button/Button';

interface ErrorHeroProps {
  subtitle: string;
  title: string;
  onSignOut?: () => void;
}

export const ErrorHero = ({ subtitle, title, onSignOut }: ErrorHeroProps) => (
  <div className={styles.container}>
    <h1 className={typography.d3}>{title}</h1>
    <p className={typography.c2}>{subtitle}</p>
    <EmailSupport className={styles.button} label="Contact us for help" />
    {onSignOut && (
      <div className={styles.buttonContainer}>
        <Button
          label="Sign Out"
          onClick={onSignOut}
          variant={ButtonVariants.Primary}
        />
      </div>
    )}
  </div>
);
